import styled from "styled-components";

interface IItemImage {
    imageUrl: string;
}

export const Container = styled.li`
    display: grid;
    grid-template-columns: 1fr 2fr;
    background-color: ${props => props.theme.colors.brand4.medium};
    border-radius: 16px;
`

export const ItemImage = styled.div<IItemImage>`
    background: url(${props => props.imageUrl}) center/cover no-repeat;
    border-radius: 16px 0 0 16px;
`

export const ItemInformationsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px;

    @media(min-width:480px){
        padding: 16px;
    }

    @media(min-width:620px){
        padding: 24px 34px;
    }

    @media(min-width:768px){
        padding: 12px;
    }
`

export const ItemInformations = styled.div`
    display: flex;
    flex-direction: column;

    > h4 {
        font-weight: 550;
        font-size: 1.1rem;
        margin-bottom: 12px;
        color:${props => props.theme.colors.typography1.pure};
            
        @media(min-width:480px){
            font-size: 1.2rem;
            margin-bottom: 24px;
        }

        @media(min-width:620px){
            font-size: 2rem;
            line-height: 40px;
        }

        @media(min-width:768px){
            font-size: 0.75rem;
            line-height: 15px;
            margin-bottom: 10px;
        }
    }

    > small {
        font-weight: 500;
        font-size: 0.8rem;
        color: ${props => props.theme.colors.typography1.dark};
        margin-bottom: 12px;

        @media(min-width:480px){
            font-size: 0.9rem;
            margin-bottom: 24px;
        }

        @media(min-width:620px){
            font-size: 1.5rem;
            line-height: 30px;
        }

        @media(min-width:768px){
            margin-bottom: 10px;
            line-height: 15px;
            font-size: 0.75rem;
        }
    }

    > strong {
        font-weight: 550;
        font-size: 1.1rem;
        color:${props => props.theme.colors.typography1.pure};
        margin-bottom: 12px;

        @media(min-width:480px){
            margin-bottom: 24px;
            font-size: 1.2rem;
        }

        @media(min-width:620px){
            font-size: 2rem;
            line-height: 40px;
        }

        @media(min-width:768px){
            margin-bottom: 12px;
            line-height: 17px;
            font-size: 0.875rem;
        }
    }
`

export const ItemInformationsButtonContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > button {
        padding: 8px 16px;
        background-color: transparent;
        border: 2px solid ${props => props.theme.colors.error.pure};
        border-radius: 16px;
        color: ${props => props.theme.colors.error.pure};
        display: flex;
        align-items: center;
        justify-content: center;

        @media(min-width:480px){
            padding: 12px 20px;
        }

        @media(min-width:620px){
            padding: 16px 24px;
        }

        @media(min-width:768px){
            padding: 8px 14px;
            border: 1px solid ${props => props.theme.colors.error.pure};
        }        

        > svg {
            margin-right: 10px;
            width: 18px;
            height: 18px;

            @media(min-width:480px){
                width: 24px;
                height: 24px;
            }

            @media(min-width:620px){
                width: auto;
                height: auto;
            }

            @media(min-width:768px){
                width: 12px;
                height: 12px;
            }
        }

        > span {
            font-weight: 500;
            font-size: 1rem;

            @media(min-width:620px){
                font-size: 1.5rem;
                line-height: 30px;
            }

            @media(min-width:768px){
                font-size: 0.625rem;
                line-height: 12px;
            }
        }
    }
`
